<template lang="pug">
header
  nav
    .nav_top_bar
      img(src="@/assets/img/media/nav_top_bar_text.png", alt="新安東京海上產險")
    .nav_main
      .menu
        .lang_btn.text-center
          svg-icon(iconClass="switch_lang")
          p
            span
              a(href="/japanese") JP
            span /
            span
              a(href="/") CH
            span /
            span
              a(href="/english") ENG
        .contact_us_btn.text-center
          router-link(tag="a", :to="{ name: 'CustomerServiceContactUs' }")
            svg-icon(iconClass="contact_us")
            p
              span Contact Us
      li.more_btn(:class="{ expand: isMoreExpand }", @click="menuExpand")
        svg-icon(
          :iconClass="isMoreExpand ? 'btn_hamburger' : 'menu_more'",
          className="icon"
        )
        .d-none.d-lg-block.i_mt_1.i_mt_sm_0(
          :class="[isMoreExpand ? 'd-block' : 'd-none']"
        ) Close
      router-link(tag="a", :to="{ name: 'Home' }")
        media-img.logo(:imgUrl="'logo'")

      links.links.d-none.d-lg-block
    more.fade(@menuExpand="menuExpand", v-show="isMoreExpand")
</template>

<script>
import { stopScroll, startScroll } from "@/utils/scroll";
import "@/assets/style/main.scss";
import Links from "@/components/eng/Link";
import MediaImg from "@/components/common/MediaImg";
import CustomMenu from "@/components/common/Navigation/Menu";
import More from "@/components/eng/More";

export default {
  components: {
    links: Links,
    "media-img": MediaImg,
    "custom-menu": CustomMenu,
    more: More,
  },
  data() {
    return {
      fullWidth: 0,
      isMoreExpand: false,
      screenWidth: document.documentElement.clientWidth, //螢幕寬度
    };
  },
  watch: {
    "$store.state.screenWidth": function (width) {
      if (Number(width) > 991) {
        this.isMoreExpand = false;
      }
    },
  },
  mounted() {
    this.onResize();
  },
  methods: {
    onResize() {
      var thiz = this;

      window.onresize = function () {
        // 定義視窗大小變更通知事件
        thiz.$store.state.screenWidth = document.documentElement.clientWidth; //視窗寬度
      };
    },
    logoClick() {
      this.$router.push({ name: "Home" });
    },
    menuExpand() {
      this.isMoreExpand = !this.isMoreExpand;
      this.isMoreExpand ? stopScroll() : startScroll();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/lang/navigation";

.nav_main {
  position: relative;
}
</style>
